import { render, staticRenderFns } from "./sticky-credit.vue?vue&type=template&id=0de0f5b0&scoped=true&"
import script from "./sticky-credit.vue?vue&type=script&lang=js&"
export * from "./sticky-credit.vue?vue&type=script&lang=js&"
import style0 from "./sticky-credit.vue?vue&type=style&index=0&id=0de0f5b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de0f5b0",
  null
  
)

export default component.exports